var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.27795 18.7793C6.43483 18.7793 4.77318 17.6691 4.06774 15.9663C3.36229 14.2635 3.75194 12.3035 5.05503 11L6.98914 9.0659L8.27795 10.3547L6.34474 12.2879C5.65391 12.9787 5.38411 13.9856 5.63697 14.9293C5.88983 15.873 6.62694 16.6101 7.57063 16.863C8.51432 17.1158 9.52123 16.8461 10.2121 16.1552L12.1453 14.222L13.4341 15.5117L11.5009 17.4449C10.6478 18.3022 9.48732 18.7827 8.27795 18.7793ZM8.92235 14.8664L7.63354 13.5776L14.0785 7.13269L15.3673 8.4215L8.92326 14.8655L8.92235 14.8664ZM16.0126 12.9332L14.7229 11.6444L16.6561 9.71121C17.3563 9.02245 17.6333 8.01103 17.3818 7.06158C17.1303 6.11213 16.3889 5.37052 15.4395 5.11878C14.4901 4.86703 13.4786 5.14382 12.7897 5.84389L10.8555 7.77709L9.56675 6.48829L11.5009 4.55418C13.2828 2.78774 16.1575 2.79404 17.9317 4.56826C19.7059 6.34248 19.7122 9.21712 17.9458 10.9991L16.0126 12.9323V12.9332Z",
    fill: "#79819A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.017990bffad707e70b0073c7a3e4baad.svg";
export { ForwardRef as ReactComponent };